import React from 'react';
import { View, Heading } from '@adobe/react-spectrum';
import { TableBody } from '@mui/material';
import { Paper, TableHead, TableRow, Table } from '@mui/material';
import { calculateTotalAmount } from '../../utils';
import { studentPaymentListHeader } from '../constant';
import { AddOnType } from '../../types';
import { CustomTableContainer as TableContainer, CustomTableCell as TableCell } from '../../../../CommonComponent/CustomTableItems';

const SummarySection: React.FC<{ finalCostComponent: AddOnType[] }> = ({ finalCostComponent }) => {
  return (
    <View>
      <Heading margin={0} level={4}>
        Summary
      </Heading>
      <View height="auto" overflow="auto" marginTop="size-200">
        <TableContainer
          component={Paper}
          sx={{
            width: '100%',
            overflowX: 'auto',
          }}
        >
          <Table stickyHeader sx={{ minWidth: studentPaymentListHeader.length * 150 }}>
            <TableHead>
              <TableRow>
                {['Component', 'Amount'].map((item, idx) => (
                  <TableCell key={idx} sx={{ backgroundColor: '#fff', fontWeight: 'bold' }} align="center">
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {finalCostComponent.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell align="center">{row.title}</TableCell>
                  <TableCell align="center">{row.amount}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell align="center">Total Amount</TableCell>
                <TableCell align="center">{calculateTotalAmount(finalCostComponent)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </View>
    </View>
  );
};

export default SummarySection;
